import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
const HoppersCadeAboutusPage = ({ components }) => {

    const getLeftComponents = (component) => {
        switch (component.ID) {
            case "HoppersCadeAboutusPage-left-subheader":
                return <div className="HoppersCadeAboutusPage-left-subheader">
                    {component?.Props?.text}
                </div>
            case "HoppersCadeAboutusPage-left-header":
                return <div className="HoppersCadeAboutusPage-left-header">
                    {component?.Props?.text}
                </div>
            case "HoppersCadeAboutusPage-left-mob-img":
                return <img className="HoppersCadeAboutusPage-left-img"
                    src={component?.Props?.src} />
            case "HoppersCadeAboutusPage-left-content":
                return <div className="HoppersCadeAboutusPage-left-content">
                    {component?.Props?.text} </div>
            case "HoppersCadeAboutusPage-left-det":
                return <div className="HoppersCadeAboutusPage-left-flex">
                    {component?.Data?.map((cont, key) => {
                        return (
                            <div className="HoppersCadeAboutusPage-left-flex-item"
                                key={key}>
                                <div className="HoppersCadeAboutusPage-left-flex-item-header">{cont?.header}</div>
                                <div className="HoppersCadeAboutusPage-left-flex-item-subheader">{cont?.subheader}</div>
                            </div>
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    const getLeftContent = (components) => {
        return (
            <div className="HoppersCadeAboutusPage-right">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getLeftComponents(component)
                    )
                })}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersCadeAboutusPage-left":
                return getLeftContent(component?.Components)
            case "HoppersCadeAboutusPage-right":
                return <div className="HoppersCadeAboutusPage-right">
                    <img className="HoppersCadeAboutusPage-right-img"
                        src={component?.Props?.src} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersCadeAboutusPage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HoppersCadeAboutusPage